/*
 * @Author:
 * @LastEditTime: 2025-11-26 11:19:22
 * @Description:
 */
import _ from 'lodash'

const fetchPictureMarkerOption = (markPictureOption, imgList) => {
  return markPictureOption.map((element, index) => {
    const option = {
      id: element.id, // 标记id
      pos: element?.pos || [0, 0, 0], // 定位点，世界坐标，三维向量
      visible: element?.visible || true, // 显示隐藏状态
      nodeOffset: element.nodeOffset,
      imgSize: element.imgSize, // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
      backgroundUrl: imgList[index], // 图片地址
      markPosType: element.markPosType || 4, // 标记位置类型，0为世界坐标，1为节点坐标
    }
    if (element.LodRange && element.LodRange.length > 2) {
      option.minLod = element.LodRange[0]
      option.maxLod = element.LodRange[1]
    }
    if (option.parentNode) delete option.pos
    return option
  })
}
// 图片标签
const createByPicture = async (player, cloudRender, markPictureOption) => {
  if (_.isEmpty(cloudRender)) {
    // 加载失败
    return {
      status: false,
      message: 'cloudRender无效',
      data: [],
    }
  }
  if (!Array.isArray(markPictureOption)) {
    markPictureOption = [markPictureOption]
  }
  // 获取需要加载标签的列表
  const imgList = markPictureOption.map((element) => {
    return element.backgroundUrl
  })
  // 批量加载标签
  const optionList = fetchPictureMarkerOption(markPictureOption, imgList)
  const optionsPtr = await cloudRender.Marker.createByPicture(optionList)
  const currentLoadMarkers = []
  currentLoadMarkers.push(
    ...optionsPtr?.data.map((el, index) => {
      return {
        id: markPictureOption[index].id,
        pointer: el,
      }
    })
  )
  return {
    status: true,
    message: '加载成功',
    data: currentLoadMarkers,
  }
}
export { createByPicture }
